const DATA_LAYER_EVENT_TYPE = {
  ADD_TO_CART: 'add_to_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  VIEW_ITEM: 'view_item',
};

const STORE_ATTRIBUTE = {
  GTM: 'store.gtm',
  PET_QUOTE_RESPONSE_LIST: 'petQuoteResponseList',
  QUOTING: 'store.quoting',
};

const PATH_ALLOWED = {
  VIEW_ITEM: ['/quoting/getquote'],
};

const NO_PARTNER = 'No Partner';
const NO_PARTNER_CODE = 'No Partner Code';
const FULL_POLICY = 'Full Policy';
const EMPTY_STRING = 'empty';
const ALL_POWERUPS = 'All Powerups';
const NO_POWERUPS = 'No Powerups';

export {
  DATA_LAYER_EVENT_TYPE,
  PATH_ALLOWED,
  NO_PARTNER,
  STORE_ATTRIBUTE,
  NO_PARTNER_CODE,
  FULL_POLICY,
  EMPTY_STRING,
  ALL_POWERUPS,
  NO_POWERUPS,
};
